// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const fearow: PokeData = {
  "id": 22,
  "name": "fearow",
  "height": 12,
  "weight": 380,
  "base_experience": 155,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "fury-attack",
    "take-down",
    "leer",
    "growl",
    "peck",
    "drill-peck",
    "agility",
    "quick-attack",
    "focus-energy",
    "mirror-move",
    "sky-attack",
    "pursuit",
    "aerial-ace",
    "roost",
    "pluck",
    "assurance",
    "drill-run"
  ],
  "moves": [
    "leer",
    "growl",
    "peck",
    "quick-attack",
    "sky-attack",
    "pursuit",
    "aerial-ace",
    "roost",
    "protect",
    "tackle",
    "chatter",
    "body-slam",
    "brave-bird"
  ],
  "evolution_chain": {
    "id": 8,
    "item": null,
    "species": [
      {
        "name": "spearow",
        "order": 21,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "fearow",
        "order": 22,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 21,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 101,
    "speed": 157,
    "ability_power": 142
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
